/*
 * @Author: your name
 * @Date: 2022-04-12 18:39:58
 * @LastEditTime: 2022-09-25 14:42:48
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\clients\controller\currency\index.ts
 */
import { BindAll } from 'lodash-decorators';
import { onCreateFactoryAuth } from '../system/auth';
import { onCreateFactoryUser } from '../system/userModel';
import { LexiangController } from './lexiang';
import { LiveController } from './live';
import { ShopController } from './shop';
import { YxtController } from './yxt';
@BindAll()
export class MiddlePageController {
  readonly User = onCreateFactoryUser();
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  readonly Auth = onCreateFactoryAuth();

  /** @dec 直播相关 */
  LiveController = new LiveController();

  /** @dec 云学堂相关 */
  YxtController = new YxtController();

  /** @dec 商城相关 */
  ShopController = new ShopController();

  /** @dec 乐享相关 */
  LexiangController = new LexiangController();
}
